import { configIdiomasAtom } from './configIdiomaState';
import { RecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useBaseActions } from '../base.actions';
import { useAxiosWrapper } from '../../services/axiosWrapper';
import { authAtom } from './../usuarios/AuthState';
import { history } from '../../helpers/history';

function useConfigIdiomasActions() {
  const baseActions = useBaseActions('configIdiomas', configIdiomasAtom, false);
  const axiosWrapper = useAxiosWrapper();
  const authState = useRecoilValue(authAtom);
  const setAuth = useSetRecoilState(authAtom);

  return {
    list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };

  async function list() {
    let url = `${process.env.REACT_APP_API_URL}/v1/assessorados/configIdiomas`;

    try {
      const recursos = await axiosWrapper.get(url);

      return recursos;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }

  }

}

export { useConfigIdiomasActions };
